import React, {useEffect} from "react";
import Api from "./services/Api";
import {useNavigate, useSearchParams} from "react-router-dom";
import {isValidUrl} from "./utility/IamLoginUtils";
import WebConstant from "./WebConstant";

const LogoutCSR = () => {
    //const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    //const [loading, setLoading] = React.useState(true);
    //const [destinationPage, setDestinationPage] = React.useState(null);

    useEffect(() => {
        async function handleLogout() {
            let DURL = searchParams.get("DURL");
            let appId = searchParams.get("appId");
            //check to see if there are cookies name cb_csr_login
            let csrLoginCookie = document.cookie
                .split("; ")
                .find((row) => row.startsWith("cb_csr_login="));
            let unifiedSessionId = "not_logged_in";
            if (csrLoginCookie) {
                // If the cookie exists, remove it
                console.log("csrLoginCookie", csrLoginCookie);
                //csrLoginCookie cb_csr_login=F88DA92A-5FF8-532F-1C61-AD99C12C82EB
                //get the unifiedSessionId from the cookie
                unifiedSessionId = csrLoginCookie.split("=")[1];
                console.log("unifiedSessionId", unifiedSessionId);
                document.cookie =
                    "cb_csr_login=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.collegeboard.org";
                document.cookie =
                    "iamkiwilog=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.collegeboard.org";
                document.cookie =
                    "cb_tree_env=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.collegeboard.org";
            }

            if (window.appConfig.envName !== "prod") {
                document.cookie =
                    "lower_Env=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.collegeboard.org";
            }

            let destinationPage = WebConstant.defaultCsrDurl;
            if (csrLoginCookie) {
                let logOutRequest = {
                    unifiedSessionId: unifiedSessionId,
                    appId: (!appId || isNaN(appId)) ? WebConstant.defaultCsrAppId : Number(appId),
                };
                console.log("logOutRequest", logOutRequest);
                if (DURL && isValidUrl(DURL)) {
                    logOutRequest.destinationUrl = DURL;
                }
                // Call mslogin to terminate CB login session
                let result = await Api.logout(logOutRequest);
                destinationPage = result.destinationUrl;
            }

            console.log(destinationPage);

            // Remove the session storage all items
            sessionStorage.clear();

            // Delete all Okta sessions
            try {
                await Api.deleteAllOktaSessions(true);
            } catch (error) {
                console.error("Error occurred when deleting Okta sessions!");
            }

            window.location = destinationPage;

        }

        handleLogout();
    }, []);
    /* return (
      <div>
        {destinationPage ? (
          <p>Debug Info only logout, redirect to {destinationPage} </p>
        ) : (
          <div>No Destination Page</div>
        )}
      </div>
    ); */
    return null;
};

export default LogoutCSR;
